// The last my_user and my_ladders sections the server sent (GET bootstrap), kept
// in this browser so a full page load can show them before the server answers.
// Startup still asks for what it shows and replaces it (app/StartupEventManager).
// Only handed back for the player it was stored for. Storage can be missing or
// blocked; every call then does nothing.

const STORAGE_KEY = 'smashladder.myUser';
const LADDERS_STORAGE_KEY = 'smashladder.myLadders';

function browserStorage() {
	return typeof window === 'undefined' ? null : window.localStorage;
}

export function cacheMyUser(user, storage = browserStorage()) {
	try {
		storage.setItem(STORAGE_KEY, JSON.stringify(user));
	} catch(error) {
		// Not stored; the next full load asks the server.
	}
}

export function cachedMyUser(userId, storage = browserStorage()) {
	if(!userId) {
		return null;
	}
	try {
		const user = JSON.parse(storage.getItem(STORAGE_KEY));
		return user && String(user.id) === String(userId) ? user : null;
	} catch(error) {
		return null;
	}
}

export function cacheMyLadders(userId, section, storage = browserStorage()) {
	try {
		storage.setItem(LADDERS_STORAGE_KEY, JSON.stringify({ userId, section }));
	} catch(error) {
		// Not stored; the next full load asks the server.
	}
}

export function cachedMyLadders(userId, storage = browserStorage()) {
	if(!userId) {
		return null;
	}
	try {
		const cached = JSON.parse(storage.getItem(LADDERS_STORAGE_KEY));
		return cached && String(cached.userId) === String(userId) ? cached.section : null;
	} catch(error) {
		return null;
	}
}

export function clearCachedMyUser(storage = browserStorage()) {
	try {
		storage.removeItem(STORAGE_KEY);
		storage.removeItem(LADDERS_STORAGE_KEY);
	} catch(error) {
		// Nothing was stored.
	}
}
